import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../App';

function MaintenanceNotice({ maintenance: providedMaintenance }) {
    const auth = useContext(AuthContext);
    const { t } = useTranslation();
    const maintenance = providedMaintenance || auth?.state?.maintenance || {};
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        setDismissed(false);
    }, [maintenance.enabled, maintenance.message]);

    if (!maintenance.enabled || dismissed) {
        return null;
    }

    return (
        <div className="maintenance-notice" role="alertdialog" aria-modal="true" aria-labelledby="maintenance-notice-title">
            <div className="maintenance-notice-backdrop"></div>
            <div className="maintenance-notice-panel">
                <button
                    className="maintenance-notice-close"
                    type="button"
                    onClick={() => setDismissed(true)}
                    aria-label={t('maintenance.close')}
                >
                    {t('maintenance.close')}
                </button>
                <span className="maintenance-notice-kicker">{t('maintenance.kicker')}</span>
                <h2 id="maintenance-notice-title">{t('maintenance.title')}</h2>
                <p>{maintenance.message || t('maintenance.message')}</p>
            </div>
        </div>
    );
}

export default MaintenanceNotice;
